export const UserActionTypes = {
    SET_FLIGHT_TOKEN:'SET_FLIGHT_TOKEN',
    SET_AIRPORT_LIST:'SET_AIRPORT_LIST',
    SET_SEARCH_FLIGHTS:'SET_SEARCH_FLIGHTS',
    SET_CALENDER_FARE:'SET_CALENDER_FARE',
    SET_SEARCH_DATA:'SET_SEARCH_DATA',
    SET_FILTER_DATA:'SET_FILTER_DATA',
    SET_FARE_RULE:'SET_FARE_RULE',
    SET_FARE_QUOTE:'SET_FARE_QUOTE',
    SET_BOTTOM_STICKY:'SET_BOTTOM_STICKY',
    SET_BOTTOM_STICKY_DATA:'SET_BOTTOM_STICKY_DATA',
    SET_BOTTOM_STICKY_DATA2:'SET_BOTTOM_STICKY_DATA2',
    SET_USER_ID:'SET_USER_ID',
    SET_AIRLINES:'SET_AIRLINES',
    SET_PASSENGER_DATA:'SET_PASSENGER_DATA',
    SET_REQUEST_PASSENGER:'SET_REQUEST_PASSENGER',
    SET_PASSENGER_IDS:'SET_PASSENGER_IDS',
}